import { ResponseBase } from '../Base';

export interface DropDownListItem  {
    id: number; 
    name: string; 
}

export interface DropdownListResponse extends ResponseBase<DropDownListItem> {
}

export const defaultDropDownListItem: DropDownListItem = {
    id: 0, 
    name: ''
}